import $ from '@/util/jQuery';
import { removeNewLine } from '@/util/String';

// Full name mapping
const fullNames = {
	anaheimducks: 'ana',
	arizonacoyotes: 'arz',
	bostonbruins: 'bos',
	buffalosabres: 'buf',
	calgaryflames: 'cgy',
	carolinahurricanes: 'car',
	chicagoblackhawks: 'chi',
	coloradoavalanche: 'col',
	columbusbluejackets: 'cbj',
	dallasstars: 'dal',
	detroitredwings: 'det',
	edmontonoilers: 'edm',
	floridapanthers: 'fla',
	losangeleskings: 'lak',
	minnesotawild: 'min',
	montrealcanadiens: 'mtl',
	nashvillepredators: 'nsh',
	newjerseydevils: 'njd',
	newyorkislanders: 'nyi',
	newyorkrangers: 'nyr',
	ottawasenators: 'ott',
	philadelphiaflyers: 'phi',
	pittsburghpenguins: 'pit',
	sanjosesharks: 'sjs',
	stlouisblues: 'stl',
	tampabaylightning: 'tbl',
	torontomapleleafs: 'tor',
	vancouvercanucks: 'van',
	vegasgoldenknights: 'vgk',
	washingtoncapitals: 'wsh',
	winnipegjets: 'wpg'
}

// Nickname Mapping
const nicknames = {
  ducks : 'ana',
  coyotes : 'arz',
  bruins : 'bos',
  sabres : 'buf',
  flames : 'cgy',
  hurricanes : 'car',
  blackhawks : 'chi',
  avalanche : 'col',
  bluejackets : 'cbj',
  stars : 'dal',
  redwings : 'det',
  oilers : 'edm',
  panthers : 'fla',
  kings : 'lak',
  wild : 'min',
  canadiens : 'mtl',
  predators : 'nsh',
  devils : 'njd',
  islanders : 'nyi',
  rangers : 'nyr',
  senators : 'ott',
  flyers : 'phi',
  penguins : 'pit',
  sharks : 'sjs',
  blues : 'stl',
  lightning : 'tbl',
  mapleleafs : 'tor',
  canucks : 'van',
  goldenknights : 'vgk',
  capitals : 'wsh',
  jets : 'wpg',
}

// All Team info
const teams = {
	ana: {
		id: 24,
    name: "Anaheim Ducks",
    abbr: "ANA",
	},
	arz: {
		id: 53,
    name: "Arizona Coyotes",
    abbr: 'ARZ'
	},
	bos: {
		id: 6,
    name: "Boston Bruins",
    abbr: 'BOS'
	},
	buf: {
		id: 7,
    name: "Buffalo Sabres",
    abbr: 'BUF'
	},
	cgy: {
		id: 20,
    name: "Calgary Flames",
    abbr: 'CGY'
	},
	car: {
		id: 12,
    name: "Carolina Hurricanes",
    abbr: 'CAR'
	},
	chi: {
		id: 16,
    name: "Chicago Blackhawks",
    abbr: 'CHI'
	},
	col: {
		id: 21,
    name: "Colorado Avalanche",
    abbr: 'COL'
	},
	cbj: {
		id: 29,
    name: "Columbus Blue Jackets",
    abbr: 'CBJ'
	},
	dal: {
		id: 25,
    name: "Dallas Stars",
    abbr: 'DAL'
	},
	det: {
		id: 17,
    name: "Detroit Red Wings",
    abbr: 'DET'
	},
	edm: {
		id: 22,
    name: "Edmonton Oilers",
    abbr: 'EDM'
	},
	fla: {
		id: 13,
    name: "Florida Panthers",
    abbr: 'FLA'
	},
	lak: {
		id: 26,
    name: "Los Angeles Kings",
    abbr: 'LAK'
	},
	min: {
		id: 30,
    name: "Minnesota Wild",
    abbr: 'MIN'
	},
	mtl: {
		id: 8,
    name: "Montréal Canadiens",
    abbr: 'MTL'
	},
	nsh: {
		id: 18,
    name: "Nashville Predators",
    abbr: 'NSH'
	},
	njd: {
		id: 1,
    name: "New Jersey Devils",
    abbr: 'NJD'
	},
	nyi: {
		id: 2,
    name: "New York Islanders",
    abbr: 'NYI'
	},
	nyr: {
		id: 3,
    name: "New York Rangers",
    abbr: 'NYR'
	},
	ott: {
		id: 9,
    name: "Ottawa Senators",
    abbr: 'OTT'
	},
	phi: {
		id: 4,
    name: "Philadelphia Flyers",
    abbr: 'PHI'
	},
	pit: {
		id: 5,
    name: "Pittsburgh Penguins",
    abbr: 'PIT'
	},
	sjs: {
		id: 28,
    name: "San Jose Sharks",
    abbr: 'SJS'
	},
	stl: {
		id: 19,
    name: "St. Louis Blues",
    abbr: 'STL'
	},
	tbl: {
		id: 14,
    name: "Tampa Bay Lightning",
    abbr: 'TBL'
	},
	tor: {
		id: 10,
    name: "Toronto Maple Leafs",
    abbr: 'TOR'
	},
	van: {
		id: 23,
    name: "Vancouver Canucks",
    abbr: 'VAN'
	},
	vgk: {
		id: 54,
    name: "Vegas Golden Knights",
    abbr: 'VGK'
	},
	wsh: {
		id: 15,
    name: "Washington Capitals",
    abbr: 'WSH'
	},
	wpg: {
		id: 52,
    name: "Winnipeg Jets",
    abbr: 'WPG'
	}
};


/**
  Given a standard STHS HTML Output, will pull the teams in the game
  @params html - The STHS HTML Output
*/
export function getTeamsFromHTMLOutput(html){
  const string = removeNewLine($(html).closest(".STHSBoxScore_Result").text());

  let [visitor, home] = string.split(' vs ');

  // Find the teams, get rid of the (R3) text if any from home team
  visitor = findTeamByName(visitor);
  home = findTeamByName(home.split('(')[0]);

  return {
    home: home.key,
    [home.key] : home,
    visitor: visitor.key,
    [visitor.key]: visitor,
  }
}

/**
  Given a standard STHS HTML Output, will pull the team stats in the game
  @params html - The STHS HTML Output
*/
export function getTeamStatsFromHTMLOutput(html){
  // Get Goals By Period
  const { vGoals, hGoals } = getTeamGoalsByPeriodFromHTMLOutput(html);

  // Get Shots by Period
  const { vShots, hShots } = getTeamShotsByPeriodFromHTMLOutput(html);

  // Team Stats
  const { vTeamStat, hTeamStat } = getTeamGameStatsFromHTMLOutput(html);

  return {
    home: {
      goals: hGoals,
      shots: hShots,
      ...hTeamStat,
    },
    visitor: {
      goals: vGoals,
      shots: vShots,
      ...vTeamStat,
    }
  }
}


/**
  Given a standard STHS HTML Output, will pull the team goals per period
  @params html - The STHS HTML Output
*/
function getTeamGoalsByPeriodFromHTMLOutput(html){
  let output = {};

  $(html)
    .find(".STHSBoxScore_GoalsTable")
    .find('.STHSBoxScore_GoalsTeamName')
    .each((index, el) => {
      let periodGoals = {};

      $(el)
        .nextUntil( ".STHSBoxScore_GoalsTotal" )
        .each((idx, el) => {
          const periodNumber = idx + 1;
          const periodText = `period${periodNumber}`;
          const goals = parseInt(el.textContent);

          periodGoals[periodText] = {
            period: periodNumber,
            goals
          }
        })

      periodGoals.total = parseInt($(el).siblings(".STHSBoxScore_GoalsTotal").text());

      // First is always visiting team
      if(index === 0){
        output.vGoals = periodGoals;
      } else{
        output.hGoals = periodGoals;
      }
    });

  return output;
}

/**
  Given a standard STHS HTML Output, will pull the team shots per period
  @params html - The STHS HTML Output
*/
function getTeamShotsByPeriodFromHTMLOutput(html){
  let output = {};
  
  $(html)
    .find(".STHSBoxScore_ShotsTable")
    .find('.STHSBoxScore_ShotsTeamName')
    .each((index, el) => {
      let periodShots = {};

      $(el)
        .nextUntil( ".STHSBoxScore_ShotsTotal" )
        .each((periodIndex, el) => {
          const periodNumber = periodIndex + 1;
          const periodText = `period${periodNumber}`;
          const shots = parseInt(el.textContent);

          periodShots[periodText] = {
            period: periodNumber,
            shots
          }
        })

      periodShots.total = parseInt($(el).siblings(".STHSBoxScore_ShotsTotal").text());

      // First is always visiting team
      if(index === 0){
        output.vShots = periodShots;
      } else{
        output.hShots = periodShots;
      }
    });
  
  return output;
}

/**
  Given a standard STHS HTML Output, will pull the team stats
  @params html - The STHS HTML Output
*/
function getTeamGameStatsFromHTMLOutput(html){
  let output = {};

  $(html)
    .find(".STHSBoxScore_TeamResult")
    .find(".STHSBoxScore_TeamStatTeamName")
    .each((index, el) => {
      const stats = {};

      // Loop through table to get stats
      $(el).siblings("td").each((idx, tdEl) => {
        switch(idx) {
          // case 0:
          //   stats.goals = parseInt(tdEl.textContent);
          //   break;
          // case 1:
          //   stats.shots = parseInt(tdEl.textContent);
          //   break;
          case 2:
            stats.attempts = parseInt(tdEl.textContent);
            break;
          case 3:
            stats.blockedShots = parseInt(tdEl.textContent);
            break;
          case 4:
            stats.pims = parseInt(tdEl.textContent);
            break;
          case 5:
            stats.hits = parseInt(tdEl.textContent);
            break;
          case 6:
            stats.pp = tdEl.textContent;
            break;
          case 7:
            stats.pk = parseInt(tdEl.textContent);
            break;
          // case 8:
          //   stats.faceoffWins = tdEl.textContent;
          //   break;
          default:
            break;
        }
      })

      // First is always visiting team
      if(index === 0){
        output.vTeamStat = stats;
      } else{
        output.hTeamStat = stats;
      }
    })
  
  // Data wrangling
  const [vGoalsStr, vRestStr] = output.vTeamStat.pp.split('/');
  const vGoals = parseInt(vGoalsStr.trim());
  const vAttempts = parseInt(vRestStr.split('(')[0].trim());

  const [hGoalsStr, hRestStr] = output.hTeamStat.pp.split('/');
  const hGoals = parseInt(hGoalsStr.trim());
  const hAttempts = parseInt(hRestStr.split('(')[0].trim());

  output.vTeamStat.pp = {
    goals: vGoals,
    attempts: vAttempts,
  }

  output.hTeamStat.pp = {
    goals: hGoals,
    attempts: hAttempts
  }

  output.vTeamStat.pk = {
    kills: (output.hTeamStat.pp.attempts - output.hTeamStat.pp.goals),
    attempts: output.hTeamStat.pp.attempts
  };
  
  output.hTeamStat.pk = {
    kills: (output.vTeamStat.pp.attempts - output.vTeamStat.pp.goals),
    attempts: output.vTeamStat.pp.attempts
  };

  return output;
}

/**
  Given a team name, will map it to our team dictionary
  @params team - string (either nickname or full name)
*/
export function findTeamByName(team) {
  let abbr = fullNameToAbbr(team);
  
  if(!abbr){
    abbr = nicknameToAbbr(team);
  }

  // Could already by a abbr
  if(!abbr) {
    abbr = team.toLowerCase();
  }
  
  return abbrToTeam(abbr);
}

/**
  Given a team name, will map it to our team dictionary
  @params team - string (either nickname or full name)
*/
export function getTeamAbbreviation(team) {
  return findTeamByName(team).key;
}

/**
  Given a team name, will find the team abbreviation
*/
function fullNameToAbbr(name){
  const formatted = name.replace(/[\W_]/g, "").toLowerCase();
  return fullNames[formatted] ? fullNames[formatted] : nicknameToAbbr(name);
}

/**
  Given a team nickname, will find the team abbreviation
*/
function nicknameToAbbr(name) {
  const formatted = name.replace(' ', '').toLowerCase();
  return nicknames[formatted];
}

/**
  Given a team abbr, will look into our team dictionary,
  and return the relevant data
*/
function abbrToTeam(abbr) {
  return {
    ...teams[abbr],
    key: abbr
  }
}

export default {
  findTeamByName,
  getTeamsFromHTMLOutput,
  getTeamStatsFromHTMLOutput,
}